/* Souled Connect — interactions. Data comes from Liquid via <script type="application/json">.
   Nothing here calls an external API; the matcher is deterministic client-side scoring. */
(function(){
  "use strict";

  /* ---------- shared: progress bar + reveals ---------- */
  var bar = document.querySelector('.sc-root .progress');
  if (bar) {
    window.addEventListener('scroll', function(){
      var h = document.documentElement;
      bar.style.width = (h.scrollTop/(h.scrollHeight-h.clientHeight)*100)+'%';
    }, {passive:true});
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });
    }, {threshold:.12});
    document.querySelectorAll('.sc-root .reveal').forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll('.sc-root .reveal').forEach(function(el){ el.classList.add('in'); });
  }

  var rupee = function(n){ return '\u20B9'+Number(n).toLocaleString('en-IN'); };
  var comm  = function(f){ return Math.round(f*0.8/10)*10; };

  /* ================= THERAPY MATCHER ================= */
  var tm = document.getElementById('sc-therapy-matcher');
  if (tm) {
    var dataEl = document.getElementById('sc-therapist-data');
    var T = [];
    try { T = JSON.parse(dataEl.textContent) || []; } catch(e){ T = []; }

    var CONCERNS = [['anxiety','anxiety & overthinking'],['depression','low moods'],
      ['relationships','relationships & family'],['grief','grief & loss'],['trauma','trauma & abuse'],
      ['anger','anger'],['adhd','ADHD & OCD'],['body','body image & self-worth'],
      ['work','burnout & work'],['fears','fears & phobias'],['child','for my child'],
      ['any','I just need to talk']];
    var LANGS = ['English','Hindi','Marathi','Gujarati','Konkani','Assamese','Malayalam','Kannada','Bengali','Telugu','Punjabi'];
    var MODES = [['online','Online'],['mumbai','In person · Mumbai'],['gurugram','In person · Gurugram']];
    var QS = [
      {q:'What are you carrying?', sub:'one tap, no explanations needed', opts:CONCERNS},
      {q:'Which language feels like home?', sub:'therapy lands deeper in your own words', opts:LANGS.map(function(l){return [l,l];})},
      {q:'Where should it happen?', sub:'our in-person spaces are in Versova and Gurugram', opts:MODES}
    ];

    var body = tm.querySelector('#mbody'), ans = [];
    function setDots(i){
      for (var k=1;k<=3;k++){ var d=tm.querySelector('#d'+k); if(d) d.classList.toggle('on', k<=i+1); }
      var lab=tm.querySelector('#dlab'); if(lab) lab.textContent = i<3 ? (i+1)+' of 3' : 'your match';
    }
    function step(i){
      setDots(i); var s=QS[i];
      body.innerHTML='<div class="mstep"><div class="mq">'+s.q+'</div><span class="mqsub">'+s.sub+'</span><div class="picks">'+
        s.opts.map(function(o){return '<button class="pick" data-v="'+o[0]+'">'+o[1]+'</button>';}).join('')+'</div>'+
        (i>0?'<button class="mback">\u2190 back</button>':'')+'</div>';
      body.querySelectorAll('.pick').forEach(function(b){
        b.onclick=function(){ ans[i]=b.dataset.v; b.classList.add('on'); setTimeout(function(){ i<2?step(i+1):think(); },240); };
      });
      var bk=body.querySelector('.mback'); if(bk) bk.onclick=function(){ ans.pop(); step(i-1); };
    }
    function think(){ setDots(3); body.innerHTML='<div class="thinking">reading the room\u2026</div>'; setTimeout(match,650); }
    function clabel(c){ var x=CONCERNS.find(function(o){return o[0]===c;}); return x?x[1]:c; }
    function match(){
      var c=ans[0], l=ans[1], m=ans[2];
      var pool=T.filter(function(t){ return (t.modes||[]).indexOf(m)>=0; });
      pool.forEach(function(t){
        t._s=0; t._why=[];
        var conc=t.concerns||[], langs=t.languages||[];
        if (c!=='any' && conc.indexOf(c)>=0){ t._s+=3; t._why.push(clabel(c)); }
        if (c==='any' && conc.length){ t._s+=1; }
        if (langs.indexOf(l)>=0){ t._s+=2; t._why.push(l); }
        if (!langs.length){ t._why.push('in person'); }
      });
      pool.sort(function(a,b){ return (b._s-a._s) || ((a.fee||0)-(b.fee||0)); });
      if (!pool.length){
        body.innerHTML='<div class="mstep"><span class="mqsub">No one is set up for that location yet. Try another mode, or browse everyone.</span>'+
          '<div class="btnrow" style="margin-top:14px"><a class="pill ghost" href="'+(tm.dataset.browse||'#')+'">Browse every therapist</a></div>'+
          '<button class="mback" style="margin-top:14px">\u2190 change my answers</button></div>';
        body.querySelector('.mback').onclick=function(){ ans=[]; step(0); }; return;
      }
      var top=pool[0], rest=pool.slice(1,3);
      var perfect = (c==='any' || (top.concerns||[]).indexOf(c)>=0 || !(top.concerns||[]).length) &&
                    ((top.languages||[]).indexOf(l)>=0 || !(top.languages||[]).length);
      var url = (m==='mumbai' && top.url_offline) ? top.url_offline : top.url;
      var h='<div class="mstep">'+
        (perfect?'':'<span class="mqsub">no exact overlap for that mix, so here are the closest hands:</span>')+
        '<div class="match"><span class="yk">your match</span>'+
        '<div class="mname">'+top.name+'</div><div class="mcred">'+(top.credential||'')+'</div>'+
        '<div class="mtags">'+
          top._why.map(function(w){return '<span class="mtag hot">'+w+'</span>';}).join('')+
          (top.approach?'<span class="mtag">'+top.approach+'</span>':'')+
          '<span class="mtag">sliding scale, just ask</span></div>'+
        '<div class="mprice"><div><b>'+rupee(top.first_fee||499)+'</b><span>first session</span></div>'+
          '<div><b>'+rupee(top.fee)+'</b><span>after that</span></div>'+
          '<div class="cl"><b>'+rupee(comm(top.fee))+'</b><span>community rate</span></div></div>'+
        '<div class="btnrow" style="margin-top:20px"><a class="pill" href="'+url+'">Book the '+rupee(top.first_fee||499)+' first session</a>'+
          '<span class="note">today, if a slot is open</span></div></div>';
      if (rest.length){
        h+='<div style="display:grid;gap:10px;margin-top:14px">'+rest.map(function(t){
          var u=(m==='mumbai'&&t.url_offline)?t.url_offline:t.url;
          return '<div class="runner"><div><div class="rn">'+t.name+'</div><div class="rm">'+(t.credential||'')+' \u00B7 then '+rupee(t.fee)+'</div></div>'+
                 '<a href="'+u+'">first session '+rupee(t.first_fee||499)+' \u2192</a></div>';
        }).join('')+'</div>';
      }
      h+='<div style="display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:10px;margin-top:18px">'+
         '<button class="mback" style="margin:0">\u2190 change my answers</button>'+
         '<span class="tiny">wrong fit after session one? the next first session is free.</span></div></div>';
      body.innerHTML=h;
      body.querySelector('.mback').onclick=function(){ ans=[]; step(0); };
    }
    if (T.length) step(0);
    else body.innerHTML='<div class="mstep"><span class="mqsub">No therapists are listed yet. Please check back soon.</span></div>';
  }

  /* ================= MENTOR BRIEF BUILDER ================= */
  var mm = document.getElementById('sc-mentor-matcher');
  if (mm) {
    var bookUrl = mm.dataset.book || '#';
    var FIELDS = [
      ['sports','Sports psychology','working with athletes and academies'],
      ['fashion','Fashion & consumer','in trend research and buying psychology'],
      ['forensic','Forensic psychology','in casework, courtrooms and investigation'],
      ['neuro','Neuropsychology','in assessment batteries and cognition research'],
      ['clinical','Clinical psychology','in clinical casework and the licensure route'],
      ['counselling','Counselling','building practices and supervising therapists'],
      ['io','I-O & organisational','in people analytics and corporate psychology'],
      ['research','Research & academia','publishing, reviewing and guiding PhD routes']
    ];
    var MISSIONS = [
      ['diss','my dissertation','The Dissertation Sprint','\u20B94,500 \u00B7 community \u20B93,600',
        ['send ahead: your topic ideas or current draft','the arc: scope \u2192 method \u2192 analysis \u2192 writing \u2192 defence','two written draft reviews between sessions, mock viva at the end']],
      ['paper','a research paper','The Decision \u00B7 3 hours','\u20B92,700 \u00B7 community \u20B92,160',
        ['send ahead: your abstract or outline','hour one: structure and journal targets','then: review rounds before you submit']],
      ['career','my career map','The Decision \u00B7 3 hours','\u20B92,700 \u00B7 community \u20B92,160',
        ['send ahead: your CV and the fork in your road','hour one: where the field is hiring and how','then: a five-year map, pressure-tested']],
      ['apply','applications & SOPs','The Decision \u00B7 3 hours','\u20B92,700 \u00B7 community \u20B92,160',
        ['send ahead: your shortlist and SOP draft','read by someone who has sat on the other side','guidance and honest odds, never guarantees']],
      ['portfolio','a portfolio review','The Conversation \u00B7 1 hour','\u20B91,000 \u00B7 community \u20B9800',
        ['send ahead: your capstone, Case File or Battery','one hour of professional-grade teardown','a written next-steps note within 48 hours']],
      ['switch','switching into the field','The Conversation \u00B7 1 hour','\u20B91,000 \u00B7 community \u20B9800',
        ['send ahead: where you are now','what transfers, what you must rebuild','the realistic first move, named']]
    ];
    var f=null, mbody=mm.querySelector('#mbody');
    function mDots(i){ var d2=mm.querySelector('#d2'); if(d2)d2.classList.toggle('on', i>0);
      var lab=mm.querySelector('#dlab'); if(lab) lab.textContent=i===0?'1 of 2':(i===1?'2 of 2':'your brief'); }
    function ms1(){ mDots(0);
      mbody.innerHTML='<div class="mstep"><div class="mq">Which field is calling?</div><span class="mqsub">we have working professionals in each</span><div class="picks">'+
        FIELDS.map(function(x){return '<button class="pick" data-v="'+x[0]+'">'+x[1]+'</button>';}).join('')+'</div></div>';
      mbody.querySelectorAll('.pick').forEach(function(b){ b.onclick=function(){ f=b.dataset.v; b.classList.add('on'); setTimeout(ms2,240); }; });
    }
    function ms2(){ mDots(1);
      mbody.innerHTML='<div class="mstep"><div class="mq">And the mission?</div><span class="mqsub">the hour bends to what you bring</span><div class="picks">'+
        MISSIONS.map(function(x){return '<button class="pick" data-v="'+x[0]+'">'+x[1]+'</button>';}).join('')+
        '</div><button class="mback">\u2190 back</button></div>';
      mbody.querySelectorAll('.pick').forEach(function(b){ b.onclick=function(){ b.classList.add('on'); setTimeout(function(){ mbrief(b.dataset.v); },240); }; });
      mbody.querySelector('.mback').onclick=ms1;
    }
    function mbrief(m){ mDots(2);
      var F=FIELDS.find(function(x){return x[0]===f;}), M=MISSIONS.find(function(x){return x[0]===m;});
      mbody.innerHTML='<div class="mstep"><div class="match"><span class="yk">your session brief</span>'+
        '<div class="mname">'+F[1]+' \u00D7 '+M[1]+'</div>'+
        '<div class="mcred">your mentor: '+F[2]+', verified in the field</div>'+
        '<div class="mtags" style="flex-direction:column;align-items:flex-start;gap:9px;margin-top:16px">'+
          M[4].map(function(x){return '<span class="mtag" style="font-size:13px;letter-spacing:0;padding:8px 14px">'+x+'</span>';}).join('')+'</div>'+
        '<div class="mprice" style="margin-top:18px"><div><b style="font-size:16px;padding-top:2px">'+M[2]+'</b><span>the right pack</span></div>'+
          '<div class="cl"><b style="font-size:16px;padding-top:2px">'+M[3]+'</b><span>what it costs</span></div></div>'+
        '<div class="btnrow" style="margin-top:20px"><a class="pill" href="'+bookUrl+'">Request this mentor hour</a>'+
          '<span class="note">mentor confirms with slot options</span></div></div>'+
        '<button class="mback">\u2190 change field or mission</button></div>';
      mbody.querySelector('.mback').onclick=ms1;
    }
    ms1();
  }

  /* ================= RATE SWITCH (mentorship packs) ================= */
  var sw = document.getElementById('rateSwitch');
  if (sw) {
    sw.querySelectorAll('button').forEach(function(b){
      b.onclick=function(){
        sw.querySelectorAll('button').forEach(function(x){ x.classList.remove('on'); });
        b.classList.add('on');
        document.querySelectorAll('.sc-root .price .amt').forEach(function(a){
          if(!a.dataset[b.dataset.r]) return;
          a.style.opacity=0;
          setTimeout(function(){ a.textContent=a.dataset[b.dataset.r]; a.style.opacity=1; },160);
        });
      };
    });
  }

  /* ================= LISTING: TWO KEYS ================= */
  var k1=document.getElementById('k1'), k2=document.getElementById('k2');
  if (k1 && k2) {
    var door=document.getElementById('door'), dk=document.getElementById('doork'),
        ap=document.getElementById('applyT'), dp=document.getElementById('doorp'),
        r1=document.getElementById('r1'), r2=document.getElementById('r2');
    function paint(){
      var a=k1.classList.contains('on'), b=k2.classList.contains('on');
      if(r1) r1.style.display=(!a&&b)?'block':'none';
      if(r2) r2.style.display=(a&&!b)?'block':'none';
      if(a&&b){ door.classList.add('open'); ap.classList.remove('off');
        dk.textContent='both keys. the wall is yours.';
        dp.textContent='payout terms in writing before you go live. application takes fifteen minutes.'; }
      else { door.classList.remove('open'); ap.classList.add('off');
        dk.textContent=(a||b)?'one key down, one to go':'tap the keys you hold';
        dp.textContent='both keys turn the lock. payout terms in writing before you go live.'; }
    }
    [k1,k2].forEach(function(k){ k.onclick=function(){ k.classList.toggle('on'); paint(); }; });
  }

})();